module.exports = __webpack_public_path__ + "static/media/Twitter_Logo.0e05a55e.svg";